import api from '../utils/axiosConfig';

export const submitFeedback = async ({ type, summary, details }) => {
  const payload = {
    type,
    summary,
    details
  };
  const response = await api.post('/api/v1/feedback', payload);
  return response.data;
};

export const fetchFeedback = async () => {
  const response = await api.get('/api/v1/feedback');
  return response.data;
};
